import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth/auth.service';
import { BilDashboardService } from '@app/home/service/bil-dashboard.service';
import { BilRequirementService } from '@app/home/service/bil-requirement.service';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';


@Component({
  selector: 'bil-bil-dashboard',
  templateUrl: './bil-dashboard.component.html',
  styleUrls: ['./bil-dashboard.component.sass']
})
export class BilDashboardComponent implements OnInit {

  public applicationStatuses: string[] = ['Ongoing', 'Approved', 'Rejected'];
  public applicationId: string = '';
  public createdDate: string = '';
  public percentComplete: number = 0;
  public applicationData: any;
  public customerName: string;
  public isMobile: boolean;
  public getRequirementDetails: any;
  public techInfoStatus: boolean = false;


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  constructor(
    private auth: AuthService,
    private router: Router,
    private bilDashboardService: BilDashboardService,
    private bilRequirementService: BilRequirementService,
    private breakpointObserver: BreakpointObserver
  ) {

    breakpointObserver
      .observe(['(min-width: 600px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobile = false;
        } else {
          this.isMobile = true;
        }
      });
  }

  ngOnInit() {
    this.bilDashboardService.getApplicationData().subscribe((response: any) => {
      console.log(response)
      if (response.data.applications.length) {
        this.customerName = response.data.customerName;
        this.applicationData = response.data.applications[0];
        this.techInfoStatus = response.data.applications[0].techInfoStatus;
        localStorage.setItem('X-BIL-ID', this.applicationData['bilId']);
        localStorage.setItem('appliaction_id', this.applicationData['appId']);
        this.getrequirementDetails(this.applicationData['bilId']);
        this.assignDashboardData(this.applicationData);
      }
    });
  }

  /**
  * @method assignDashboardData
  * @description method to assign dashboard data
  * @param {Object} appData
  * @return void
  */
  assignDashboardData(appData): void {
    this.percentComplete = appData.progress;
    this.applicationId = appData.appId;
    this.createdDate = appData.createdDate;
  }

  /**
  * @method viewBasicDetails
  * @description navigating to bil requirement page
  * @param void
  * @return void
  */
  viewBasicDetails(): void {
    this.router.navigate(['/bil/requirement']);
  }


  /**
  * @method resumeApplication
  * @description navigating to upload document screen
  * @param void
  * @return void
  */
  resumeApplication(): void {
    if (this.applicationData.documentUploadProgress == 100
      && this.applicationData.documentUploadProgress == 100
      && this.applicationData.progress == 100) {
      // this.router.navigate(['/bil/application-submitted/processing-app']);
      this.handleSubmittedAppliactionNavigation();
    } else if (this.techInfoStatus) {
      // this.router.navigate(['/bil/application-submitted/processing-app']);
      this.handleSubmittedAppliactionNavigation();
    } else if (this.getRequirementDetails.data.appStatus == "GW_REJECTED") {
      this.router.navigate(['/bil/requirement']);
    }
    else {
      this.router.navigate(['/bil/upload-document']);
    }
  }

  /**
  * @method handleSubmittedAppliactionNavigation
  * @description navigating to upload document screen with FI Date
  * @param void
  * @return void
  */
 handleSubmittedAppliactionNavigation() {
   this.bilDashboardService.getFIApplicationData().subscribe((response: any) => {
     console.log(response)
    if(Object.keys(response).length) {
      switch(response.applicationStatus) {
        case 'Terms Created':
        case 'Check Offer Rejected':
        case 'TnC - Approved':
        case 'Agreement In Progress':
        case 'Agreement Stage':
          this.router.navigate(['/bil/application-submitted/check-offer']);
          break;
        case 'Agreement Signed':
          this.router.navigate(['/bil/application-submitted/loan-sanction']);
          break;
        case 'Disbursed':
          this.router.navigate(['/bil/application-submitted/disbursal']);
          break;
        case 'Processing Application Rejected':
          this.router.navigate(['/bil/application-submitted/processing-app']);
            break;
        default:
          this.router.navigate(['/bil/application-submitted/processing-app']);
      }
    } else {
      this.router.navigate(['/bil/application-submitted/processing-app']);
    }
   }, error => {
     // error handling
   })
 }

  /**
  * @method bilLogout
  * @description logging out bil user
  * @param {String} bil_id
  * @return void
  */
  getrequirementDetails(bil_id): void {
    this.bilRequirementService.getRequirementDetails(bil_id).subscribe((response: any) => {
      console.log(response)
      this.getRequirementDetails = response;
      let panOrGst = response.data['panOrGst'];
      let custType = '';

      if (panOrGst.length === 10) {
        custType = panOrGst.charAt(3);
      } else if (panOrGst.length === 15) {
        custType = panOrGst.charAt(5);
      }

      localStorage.setItem('pan/gst', custType);
      localStorage.setItem('X-SOLV-ID', response.data['solvId']);
      localStorage.setItem('X-CUST-ID', response.data['orgId']);
    })
  }

  /**
  * @method bilLogout
  * @description logging out bil user
  * @param void
  * @return void
  */
  async signOut() {
    await this.auth.signOut();
    this.router.navigate(['/registration/register']);
  }

}

